export enum IndexType {
    Key = 'key',
    Fulltext = 'fulltext',
    Unique = 'unique',
    Spatial = 'spatial',
}